import moment from 'moment';
import Axios from 'axios';
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('Language', ['getLanguage']),
    },
    watch: {
        bool_isAMV(newValue) {
            if (!newValue) {
                this.cleanSuccessErrorMessage();
            }
        },
    },
    methods: {
        substrContent(ct, intCount) {
            if (ct != '' && ct != null) {
                if (ct.length <= intCount) {
                    return ct;
                } else {
                    return ct.substr(0, intCount) + "...";
                }

            } else {
                return ct;
            }


        },
        CheckIsThousandCurrency(currencyCode, parent) {
            var ThousandCurrency = ['IDR', 'VND', 'KHR', 'LAK', 'MMK', '₫', '៛', '₭', 'K'];
            var isThousandCurrency = false;
            for (var j = 0; j < ThousandCurrency.length; j++) {
                var sThousandCurrency = ThousandCurrency[j];
                if (currencyCode.toLowerCase() == sThousandCurrency.toLowerCase()) {
                    isThousandCurrency = true;
                    break;
                }
            }
            if (isThousandCurrency) {
                return true;
            } else {
                return false;
            }

        },
        ThousandSeparator(value, decimalPoint = 2) {
            if (value == null || value == "" || isNaN(value)) {
                var num = 0;
                value = num.toFixed(decimalPoint);
                return value;
            }

            if (value != null) {
                value = value.toString().replaceAll(',', '');
            }
            if (parseFloat(value) > 0) {
                value = this.formatThousandSeperator(parseFloat(value), ".", ",", decimalPoint);
            } else {
                var num = 0;
                value = num.toFixed(decimalPoint);
            }
            return value;
        },
        ThousandSeparatorWithNegative(value, decimalPoint = 2) {
            if (value == null || value === "" || !this.isNumeric(value)) {
                return (0).toFixed(decimalPoint);
            }

            value = value.toString().replaceAll(',', '');

            let parsedValue = parseFloat(value);

            if (!isNaN(parsedValue)) {
                const isNegative = parsedValue < 0;
                let fixedValue = Math.abs(parsedValue).toFixed(decimalPoint);
                let formattedValue = this.formatThousandSeperator(fixedValue, ".", ",", decimalPoint);
                return isNegative ? `-${formattedValue}` : formattedValue;
            }

            return (0).toFixed(decimalPoint);
        },
        RemoveThousandSeparatorWithNegative(value, decimalPoint = 2) {
            if (value == null || value === "" || !this.isNumeric(value)) {
                return (0).toFixed(decimalPoint);
            }

            value = value.toString().replaceAll(',', '');

            let parsedValue = parseFloat(value);

            if (!isNaN(parsedValue)) {
                return parsedValue.toFixed(decimalPoint);
            }

            return (0).toFixed(decimalPoint);
        },
        isNumeric(value) {
            return /^-?\d*\.?\d+$/.test(value);
        },
        RemoveThousandSeparator(value, decimalPoint = 2) {
            if (value == null || value == "" || isNaN(value)) {
                return value;
            }
            if (value != null) {
                value = value.toString().replaceAll(',', '');
            }
            return parseFloat(value).toFixed(decimalPoint);
        },
        deepClone(arry) {
            return JSON.parse(JSON.stringify(arry));
        },
        mapLanguageFlag(languageCode) {
            switch (languageCode) {
                case "en":
                    languageCode = "gb";
                    break;
                case "lo":
                    languageCode = "la";
                    break;
                case "ja":
                    languageCode = "jp";
                    break;
                case "ar":
                    languageCode = "ae";
                    break;
                case "hi":
                    languageCode = "in";
                    break;
                case "mn":
                    languageCode = "la";
                    break;
                case "pt":
                    languageCode = "br";
                    break;
                case "bn":
                    languageCode = "bd";
                    break;
                case "ne":
                    languageCode = "np";
                    break;
                default:
                    break;
            }

            return "cif-" + languageCode;
        },
        formatDate(dateString, fromDateFormat = null, toDateFormat = null, empty1900 = false) {
            if (dateString) {
                if (toDateFormat == null) {
                    toDateFormat = "DD/MM/YYYY";
                }

                if (fromDateFormat) {
                    var t = moment(String(dateString), fromDateFormat);
                    if (empty1900 && t.format('YYYY') == '1900') {
                        dateString = '';
                    } else {
                        dateString = t.format(toDateFormat);
                    }
                } else {
                    var t = moment(String(dateString));
                    if (empty1900 && t.format('YYYY') == '1900') {
                        dateString = '';
                    } else {
                        dateString = t.format(toDateFormat);
                    }
                }
            }

            return dateString;
        },
        formatDateTime(dateString, fromDateFormat = null, toDateFormat = null, empty1900 = false) {
            if (dateString) {
                if (toDateFormat == null) {
                    toDateFormat = "DD/MM/YYYY HH:mm";
                }

                if (fromDateFormat) {
                    var t = moment(String(dateString), fromDateFormat);
                    if (empty1900 && t.format('YYYY') == '1900') {
                        dateString = '';
                    } else {
                        dateString = t.format(toDateFormat);
                    }
                } else {
                    var t = moment(String(dateString));
                    if (empty1900 && t.format('YYYY') == '1900') {
                        dateString = '';
                    } else {
                        dateString = t.format(toDateFormat);
                    }
                }
            }

            return dateString;
        },
        isEmptyDate(dateString, dateFormat = null) {
            if (dateString) {
                if (dateFormat) {
                    dateString = moment(String(dateString), dateFormat).format("DD/MM/YYYY");
                } else {
                    dateString = moment(String(dateString)).format("DD/MM/YYYY");
                }

                if (dateString == "01/01/1900") {
                    return true;
                }
            }

            return false;
        },
        defaultDateRangePickerUpdateEvent(dt) {
            if (dt) {
                if (dt.startDate) {
                    dt.startDate.setHours(0, 0, 0, 0);
                }

                if (dt.endDate) {
                    dt.endDate.setHours(23, 59, 59, 59, 997);
                }
            }
        },
        getTodayDate() {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return today;
        },
        getMinStartDate() {
            var today = new Date();
            today.setMonth(today.getMonth() - 1);
            return today;
        },
        getMonthStartDate() {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            return firstDay;
        },
        getMonthEndDate() {
            var testEnd = moment().endOf('month').format('YYYY-MM-DD');
            testEnd = testEnd + " 23:59:59.997"
            return testEnd;
        },
        getYesterdayStartDate() {
            const today = new Date()
            const yesterday = new Date(today)

            yesterday.setDate(yesterday.getDate() - 1)

            return yesterday.setHours(0, 0, 0, 0);
        },
        getTodayEndDate() {
            var today = new Date();
            today.setHours(23, 59, 59, 59, 997);
            return today;
        },
        setEndDate(date) {
            var EndDate = new Date(date);
            EndDate.setHours(23, 59, 59, 59, 997);
            return EndDate;
        },
        getMinimumDate() {
            return new Date(1900, 0, 1, 0, 0, 0, 0);
        },
        getMaximumDate() {
            return new Date(9999, 0, 1, 0, 0, 0, 0);
        },
        getCurrentMonth() {
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var m = new Date();
            return months[m.getMonth()];
        },
        getDefaultDateRange(showThisYear = false) {
            var dateRange = {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'This week': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                'This month': [moment().startOf('month'), moment().endOf('month')],
                'This year': [moment().startOf('year'), moment().endOf('year')],
                'Last week': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
                'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            }
            if (!showThisYear)
                delete dateRange['This year'];
            return dateRange;
        },
        formatNumber(number, decimalPoint = 2, currencySymbol = "", showCurrencySymbol = true) {
            var decimalSymbol = '.';
            var thousandSeperator = ',';

            if (number !== '-' && !isNaN(number)) {
                if (currencySymbol && currencySymbol !== "" && decimalPoint != 0 && this.CheckIsThousandCurrency(currencySymbol)) {
                    decimalPoint = 3;
                }
                var sign = number >= 0 ? "" : "-";
                number = Math.abs(number);
                var parts = number.toFixed(decimalPoint).split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeperator);

                return sign + ((currencySymbol && showCurrencySymbol) ? (currencySymbol + " ") : "") +  parts.join(decimalSymbol);
            } else {
                return '-';
            }
        },
        formatShortenNumberWithoutSymbol(number, decimalSymbol = '.', thousandSeperator = ',', decimalPoint = 2, currencySymbol = "") {
            if (number !== '-' && !isNaN(number)) {
                if (currencySymbol && currencySymbol !== "" && decimalPoint != 0 && this.CheckIsThousandCurrency(currencySymbol)) {
                    decimalPoint = 3;
                }
                var sign = number >= 0 ? "" : "-";
                number = Math.abs(number);

                var maxnumber = number >= 0 ? 99999 : 9999;
                if (maxnumber == 99999 && decimalPoint == 3) maxnumber = 999;

                if (number < maxnumber) {
                    var parts = number.toFixed(decimalPoint).split('.');
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeperator);

                    return sign + parts.join(decimalSymbol);
                }
                let si = [
                    { v: 1E3, s: "K" },
                    { v: 1E6, s: "M" },
                    { v: 1E9, s: "B" },
                    { v: 1E12, s: "T" },
                    { v: 1E15, s: "P" },
                    { v: 1E18, s: "E" }
                ];
                let index;
                for (index = si.length - 1; index > 0; index--) {
                    if (number >= si[index].v) {
                        break;
                    }
                }
                return sign + (number / si[index].v).toFixed(decimalPoint).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[index].s;
                
            } else {
                return '-';
            }
        },
        formatThousandSeperator(number, decimalSymbol = '.', thousandSeperator = ',', decimalPoint = 2) {
            number = Math.abs(number);
            var parts = number.toFixed(decimalPoint).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeperator);
            return parts.join(decimalSymbol);
        },
        parseDateToJsonString(date) {
            var dateString = '';
            if (date) {
                dateString = moment(date).format("YYYY-MM-DD HH:mm:ss.SSS");
                dateString = dateString.replace(".059", ".997");
            }

            return dateString;
        },
        set90daysDateSearch(startDate) {
            //var z = moment(startDate);
            //var date1 = new Date(z);
            //var date2 = new Date(moment().format('MM/DD/YYYY'));
            //var Difference_In_Timetest = date2.getTime() - date1.getTime();
            //var Difference_In_Daystest = Difference_In_Timetest / (1000 * 3600 * 24);
            //if (Difference_In_Daystest > 90) {
            //    this.showErrorMessage(this.utilGetErrorLanguage("TWL.SDET"), this.utilGetErrorLanguage("TWL.SDEM"));
            //    return true;
            //}
            //else {
            return false;
            //}
        },
        handlerResponse(data, errCLNoLanguage) {
            var success = true;
            var bool_checkLogIn = false;
            if (data && data.S == false && data.ERR && data.ERR.length > 0) {
                success = false;
                var msg = '';
                var temp = '';
                var title = this.utilGetErrorLanguage("ERR.TI");
                for (var i = 0; i < data.ERR.length; i++) {
                    if (data.ERR[i].ERRC == -1) {
                        bool_checkLogIn = true;
                        title = this.utilGetErrorLanguage("ERR.UNA");
                    }
                    if (data.ERR[i].ERRC && data.ERR[i].CL && data.ERR[i].CL.length > 0) {
                        //temp = String.format(this.utilGetErrorLanguage(data.ERR[i].ERRC), this.splitColumnName(data.ERR[i].CN));
                        var arr_args = errCLNoLanguage ? data.ERR[i].CL : this.splitColumnName(data.ERR[i].CL);
                        arr_args.unshift(this.utilGetErrorLanguage(data.ERR[i].ERRC));
                        temp = String.format.apply(this, arr_args);
                    } else if (data.ERR[i].ERRC) {
                        temp = this.utilGetErrorLanguage(data.ERR[i].ERRC);
                    } else if (data.ERR[i].CL && data.ERR[i].CL.length > 0) {
                        if (data.ERR[i].CL.length == 1)
                            temp = this.utilGetErrorLanguage(data.ERR[i].CL[0]);
                        else {
                            var arr_ags = this.splitColumnName(data.ERR[i].CL);
                            temp = arr_ags.join("<br />");

                        }
                    }

                    if (temp && data.ERR[i].PF) {
                        temp = data.ERR[i].PF + temp;
                    }
                    if (temp && data.ERR[i].ED) {
                        temp = temp+": "+data.ERR[i].ED ;
                    }

                    msg += temp + "<br/>";
                }
                if (bool_checkLogIn) {
                    Axios.get(`/api/user/g`).then(function({ data }) {
                        if (data && data.S && data.D) {

                        } else {
                            window.location.href = "/auth/logout";
                        }
                    });
                }

                this.showErrorMessage(title, msg);
            }

            return success;
        },
        splitColumnName(arr_cn) {
            for (var k = 0; k < arr_cn.length; k++) {
                arr_cn[k] = this.utilGetErrorLanguage(arr_cn[k]);
            }

            return arr_cn;
        },
        getListingParamQuery(p, n, s, d) {
            var path = "";
            var tmp = "";

            if (p) {
                tmp = "&p=" + p;
                path += tmp;
            }

            if (n) {
                tmp = "&n=" + n;
                path += tmp;
            }

            if (s) {
                tmp = "&s=" + s;
                path += tmp;
            }

            if (d != undefined && d != null) {
                if (d == 1) {
                    d = true;
                } else if (d == 0) {
                    d = false;
                }
                tmp = "&d=" + d;
                path += tmp;
            }
            if (path) {
                path = path.substring(1);
            }
            return path;
        },
        getDataApi(url, func) {
            Vue.notify({ clean: true, group: 'msgNotification' });
            var that = this;
            if (url.indexOf('?') == -1)
                url += "?version=" + Date.now();
            else
                url += "&version=" + Date.now();
            url = url.replaceAll("&&", "&");
            return Axios.get(`${url}`).then(function({ data }) {
                var success = that.handlerResponse(data);
                if (func) {
                    func(data, success);
                }
            })
        },
        postDataApi(url, data, func, errCLNoLanguage) {
            Vue.notify({ clean: true, group: 'msgNotification' });
            var that = this;
            return Axios.post(`${url}`, data).then(function({ data }) {
                var success = that.handlerResponse(data, errCLNoLanguage);
                if (func) {
                    func(data, success);
                }
            }, function(re) {
                if (func) {
                    func(data, false);
                }
            });
        },
        postDataApiWithAttach(url, data, func) {
            Vue.notify({ clean: true, group: 'msgNotification' });

            var form_data = this.objectToFormData(data);

            var that = this;
            return Axios.post(`${url}`, form_data).then(function({ data }) {
                var success = that.handlerResponse(data);
                if (func) {
                    func(data, success);
                }
            }, function(re) {
                if (func) {
                    func(data, false);
                }
            });
        },
        objectToFormData(obj, form, namespace, isArray) {

            var fd = form || new FormData();
            var formKey;

            for (var property in obj) {
                if (obj.hasOwnProperty(property)) {

                    if (namespace) {
                        if (isArray) {
                            formKey = namespace + '[' + property + ']';
                        } else {
                            formKey = namespace + '.' + property;
                        }
                    } else {
                        formKey = property;
                    }

                    // if the property is an object, but not a File,
                    // use recursivity.
                    if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {

                        this.objectToFormData(obj[property], fd, formKey, Array.isArray(obj[property]));

                    } else {

                        // if it's a string or a File object
                        fd.append(formKey, obj[property]);
                    }
                }
            }

            return fd;
        },

        showApproveSuccessMessage(title, message) {
            this.$fire({
                title: title,
                html: message,
                width: '30em',
                customClass: {
                    title: 'afb-alert-title',
                    content: 'afb-alert-content',
                    actions: 'afb-alert-action'
                }
            });
        },
        showSuccessMessage(title, message) {
            //Vue.notify({
            //    group: 'msgNotification',
            //    type: 'success',
            //    title: title,
            //    text: message,
            //    duration: 2000


            //});
            this.$fire({
                // type: 'error',
                title: title,
                html: message,
                width: '30em',
                keydownListenerCapture: true,
                customClass: {
                    title: 'afb-alert-title',
                    content: 'afb-alert-content',
                    actions: 'afb-alert-action'
                },
                onOpen: () => {
                    const confirmButton = document.querySelector('.afb-alert-action button');
                    if (confirmButton) {
                        confirmButton.focus();
                    }                 
                }
            });
        },
        showErrorMessage(title, message, duration) {
            if (title == null || title == undefined) {
                title = this.utilGetErrorLanguage("ERR.TI");
            }

            let isGGEarn = document.getElementsByClassName("marketingApp");
            this.$fire({
                // type: 'error',
                title: isGGEarn.length > 0 ? (title + " !!!!") : title,
                html: message,
                width: isGGEarn.length > 0 ? '20em' : '30em',
                customClass: {
                    title: isGGEarn.length > 0 ? 'afb-alert-title text-danger' : 'afb-alert-title',
                    content: 'afb-alert-content',
                    actions: 'afb-alert-action'
                }
            });
        },
        cleanSuccessErrorMessage() {
            Vue.notify({ clean: true, group: 'msgNotification' });
        },
        utilGetErrorLanguage(text) {
            var strResult = text,
                result = text;
            try {
                if (result) {
                    if (typeof result == 'number') {
                        strResult = result = result.toString();
                    }

                    var arr = result.split('.');
                    if (arr) {
                        if (arr.length > 1) {
                            if (arr[0] == "VAL")
                                result = arr[1];
                            else
                                result = this.getLanguage[arr[0]][arr[1]];
                        } else if (arr.length == 1 && this.getLanguage["ERR"][arr[0]] !== undefined) {
                            result = this.getLanguage["ERR"][arr[0]];
                        }
                    }
                }
            } catch (ex) {
                result = strResult;
            }

            return result;
        },
        utilGetDDLanguage(text) {
            var result = text;
            try {
                result = String.format(this.getLanguage["GL"]["DDS"], this.utilGetErrorLanguage(result));
            } catch (ex) {}

            return result;
        },
        getActiveDropdownOptions() {
            return [{ id: '2', label: this.getLanguage["GL"]["AC"] }, { id: '1', label: this.getLanguage["GL"]["IAC"] }];
        },
        convertToBool(value) {
            if (value) {
                return true;
            }

            return false;
        },
        getImgUrl(path) {
            if (path) {

                var filename = path.substring(path.lastIndexOf('/') + 1);
                var encodedFileName = encodeURIComponent(filename);
                var newpath = path.replace(filename, encodedFileName);

                if (!newpath.startsWith('http')) {
                    newpath = window.baseURL + '/file/img/' + newpath;
                }
            }

            return newpath;
        },
        uploadImgUr(imgUrClientId, imgFile, filename, func) {
            var formData = new FormData();
            formData.append('image', imgFile);

            if (filename) {
                formData.append('name', filename);
            }

            Axios({
                    url: 'https://api.imgur.com/3/image',
                    method: 'POST',
                    headers: {
                        'Authorization': 'Client-ID ' + imgUrClientId
                    },
                    data: formData
                })
                .then((result) => {
                    let url = result.data.data.link

                    if (func && url != "") {
                        func(url, true);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (func) {
                        func("", false);
                    }
                });
        },
        formatString(string, args) {
            return string.replace(new RegExp("{-?[0-9]+}", "g"), function(item) {
                var intVal = parseInt(item.substring(1, item.length - 1));
                var replace;
                if (intVal >= 0) {
                    replace = args[intVal];
                } else if (intVal === -1) {
                    replace = "{";
                } else if (intVal === -2) {
                    replace = "}";
                } else {
                    replace = "";
                }
                if (replace == undefined)
                    replace = '';
                return replace;
            });
        },
        when(func, done) {
            if (!Array.isArray(func)) func = [func];
            let promises = func.map(function(call) {
                return new Promise(call);
            });
            Promise.all(promises).then(done);
        },
        validateFile(event, maxFileSize = 1, validFileExtension = [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".webp"]) {
            var file = null;
            var files = event.target.files;

            if (files && files.length > 0) {
                var filesize = ((files[0].size / 1024) / 1024).toFixed(4); // MB

                if (filesize <= maxFileSize) {
                    var blnValid = false;
                    for (var j = 0; j < validFileExtension.length; j++) {
                        var sCurExtension = validFileExtension[j];
                        if (files[0].name.substr(files[0].name.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                            blnValid = true;
                            break;
                        }
                    }

                    files[0].name.substr(files[0].name.length - sCurExtension.length, sCurExtension.length)
                    var fileName = files[0].name.substr(0, files[0].name.length - sCurExtension.length).trim();
                    fileName = fileName.replace(/[^a-zA-Z0-9-_\s]/g, '');

                    if (fileName != files[0].name.substr(0, files[0].name.length - sCurExtension.length)) {
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4030")));
                        event.target.value = '';
                    } else if (blnValid) {
                        file = files[0];
                    } else {
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4020"), files[0].name) + validFileExtension.join(", "));
                        event.target.value = '';
                    }
                } else {
                    // upload bank QR Code limited size 100KB
                    if (maxFileSize == 0.1) {
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), this.utilGetErrorLanguage("ERR.MFS100KB"));
                        event.target.value = '';
                    }
                    // Outlet deposit in module 3.1, upload receipt limited size 200KB
                    else if (maxFileSize == 0.2) {
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), this.utilGetErrorLanguage("ERR.4040"));
                        event.target.value = '';
                    }
                    else if (maxFileSize < 1) {
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.MFSKB"), (maxFileSize * 1000).toString()));
                        event.target.value = '';
                    }
                    else if (maxFileSize >= 1) {
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.MFSMB"), maxFileSize.toString()));
                        event.target.value = '';
                    }
                    else {
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), this.utilGetErrorLanguage("ERR.4010"));
                        event.target.value = '';
                    }
                }
            }

            return file;
        },
        validateURL(link) {
            return link;
            // var validatedlink = link;
            // var hostname = new URL(validatedlink).hostname;
            // if (/^\d+(\.\d+)*$/.test(hostname)) {
            //     validatedlink = validatedlink.replace("https://", "http://");
            //     return validatedlink;
            // } else {
            //     return validatedlink;
            // }
        },
        appendSelectAllOption(options) {
            return [{ id: 0, label: this.getLanguage['GL']['ALL'], children: options }];
        },
        renderProviderName(providerName) {
            if (providerName && providerName in this.getLanguage['GP'])
                return this.getLanguage['GP'][providerName];
            else
                return providerName;
        },
        renderAction(actionName) {
            if (actionName && actionName in this.getLanguage['AC'])
                return this.getLanguage['AC'][actionName];
            else
                return actionName;
        },
        //renderStatusName(StatusName) {
        //    if (StatusName && StatusName in this.getLanguage['CTNT']) // CTNT IS KEY1
        //        return this.getLanguage['CTNT'][StatusName];
        //    else
        //        return StatusName;
        //},
        renderLanguage(key, value) {
            if (value && key && this.getLanguage && this.getLanguage[key] && value in this.getLanguage[key])
                return this.getLanguage[key][value];
            else
                return value;
        },
        renderCategoryName(categoryName) {
            categoryName = categoryName.replace(" ", "")
            if (categoryName && categoryName in this.getLanguage['AGD'])
                return this.getLanguage['AGD'][categoryName];
            else
                return categoryName;
        },
        getMaxDisplayPerList(module) {
            var val_defualt = 100;

            if (module) {
                if (module == 'MAPP') {
                    return 50;
                } else {
                    return val_defualt;
                }
            } else {
                return val_defualt;
            }
        },
        HideInfo(isHide, target, showCha, replaceWith = '*') {
            var result = "";
            if (isHide && target != null && target != "") {
                if (target.length > showCha) {
                    var repeatWith = replaceWith;
                    repeatWith = repeatWith.repeat(target.length - showCha);
                    result = repeatWith + target.substr(target.length - showCha, showCha);
                } else {
                    var repeatWith = replaceWith;
                    repeatWith = repeatWith.repeat(target.length);
                    result += repeatWith;
                }
            } else {
                result = target;
            }
            return result;
        },
        getLanguageOEMI(int_OEMId, key1, key2) {

            if (int_OEMId != 0) {
                var key2_T = key2 + "_" + int_OEMId.toString()
                if (key1 in this.getLanguage && key2_T in this.getLanguage[key1]) {
                    return this.getLanguage[key1][key2_T];

                }
            }
            return this.getLanguage[key1][key2];
        },
        renderAgentGroupName(GroupName, GroupPrefix = '') {
            if (GroupPrefix == '0000') {
                return this.getLanguage['WLRPT']['SA'];
            }else if(GroupName != "" && GroupPrefix != "")
            {
                return GroupName + " (" + GroupPrefix + ")";
            }
            else{
                return GroupName;
            }
        },
        //find the input which is required and failed to validate.
        findRequiredInput(validation, refs, predicateRef) {
            //create an array to collect and sort the elements from the $refs.
            const refIndexes = [];
            for (let refName of Object.getOwnPropertyNames(refs)) {
                const ref = refs[refName];
                if (!ref) {
                    continue;
                }

                refIndexes.push({ uid: ref._uid, name: refName, component: ref });
            }
            refIndexes.sort((a, b) => {
                if (a.uid > b.uid) {
                    return 1;
                } else if (a.uid < b.uid) {
                    return -1;
                } else {
                    return 0;
                }
            });

            const allowedNodes = ["INPUT", "TEXTAREA", "BUTTON"];
            //a function for finding a specified input which is a raw HTML element.
            function getInput(element, deep, start) {
                if (!element) {
                    return null;
                }

                if (allowedNodes.find(name => element.nodeName === name)) {
                    return element;
                }

                if (!element.children) {
                    return null;
                }

                let floor = 0;
                floor = floor + start;
                if (floor > deep - 1) {
                    return null;
                }

                for (let child of element.children) {
                    if (child.nodeName === "INPUT" || child.nodeName === "TEXTAREA") {
                        return child;
                    }

                    const input = getInput(child, deep, floor + 1);
                    if (!input) {
                        continue;
                    }
                    return input;
                }
                return null;
            }
            //a function for finding a specified property which is in the $v.
            function getProp(startProp, namePath) {
                const names = namePath.split(".");
                let upperProp = startProp;
                let prop = null;
                for (let i = 0; i < names.length; i++) {
                    const name = names[i];
                    prop = upperProp[name];
                    if (!prop) {
                        return null;
                    }

                    if (name === names[names.length - 1]) {
                        return prop;
                    }

                    upperProp = prop;
                }
            }

            //get the first component which is failed to validate.
            let ref = null;
            for (let refIndex of refIndexes) {
                if (predicateRef) {
                    ref = predicateRef(refIndex, getProp);
                } else {
                    const validationProp = getProp(validation, refIndex.name);
                    if (!validationProp || !validationProp.$error) {
                        continue;
                    }

                    ref = refIndex.component;
                }

                if (ref) {
                    break;
                }
            }

            //get the raw HTML element.
            const element = ref.$el ? ref.$el : ref;
            return getInput(element, 5, 0);
        },
        /* Replace route parameter's special characters
            '.' to '_DOT_'
            '/' to '_SLASH_'
            '?' to '_QMARK_'
            '=' to '_EQUALS_'
            '&' to '_AMP_'
            '%' to '_PERCENT_'
            */
        customEncodeRouteParameter(param) {
            //Return empty string if null
            if (!param) { return ""; }
            //Convert to string so can use replace
            param = String(param);
            //Replace special characters
            return param
                .replace(/\./g, '_DOT_')
                .replace(/\//g, '_SLASH_')
                .replace(/\?/g, '_QMARK_')
                .replace(/=/g, '_EQUALS_')
                .replace(/&/g, '_AMP_')
                .replace(/%/g, '_PERCENT_');
        },
        customDecodeRouteParameter(param) {
            if (!param) { return ""; }
            param = String(param);
            return param
                .replace(/_DOT_/g, ".")
                .replace(/_SLASH_/g, "/")
                .replace(/_QMARK_/g, "?")
                .replace(/_EQUALS_/g, "=")
                .replace(/_AMP_/g, "&")
                .replace(/_PERCENT_/g, "%");
        }
    },
    filters: {
        //formatNumber(value) {
        //    try {
        //        if (typeof value !== "number") {
        //            if (value != "" && !isNaN(value)) {
        //                value = parseFloat(value);
        //            } else {
        //                return value;
        //            }
        //        }

        //        value = Math.floor(value * 100) / 100;
        //        var formatter = new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        //        return formatter.format(value);
        //    } catch (ex) {
        //        return value;
        //    }
        //}
    }
};



// WEBPACK FOOTER //
// ./src/modules/GenericHelper.js